import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import zhHant from "./locales/zh-Hant.json";

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    "zh-Hant": { translation: zhHant },
  },
  lng: "zh-Hant",
  fallbackLng: "zh-Hant",
  supportedLngs: ["zh-Hant", "en"],
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
